import ApiClient from '@/libs/http-client'

const EstimationsService = {
    listEstimations(params = {}, config = {}) {
        return ApiClient.get('/api/estimations', { ...config, params })
    },
    getEstimation(id, config = {}) {
        return ApiClient.get(`/api/estimations/${id}`, config)
    },
    createEstimation(payload, config = {}) {
        return ApiClient.post('/api/estimations', payload, config)
    },
    updateEstimation(id, payload, config = {}) {
        return ApiClient.put(`/api/estimations/${id}`, payload, config)
    },
    deleteEstimation(id, config = {}) {
        return ApiClient.delete(`/api/estimations/${id}`, config)
    },

    listStacks(params = {}, config = {}) {
        return ApiClient.get('/api/estimations/estimation-stacks', { ...config, params })
    },
    createStack(payload, config = {}) {
        return ApiClient.post('/api/estimations/estimation-stacks', payload, config)
    },
    updateStack(id, payload, config = {}) {
        return ApiClient.put(`/api/estimations/estimation-stacks/${id}`, payload, config)
    },
    deleteStack(id, config = {}) {
        return ApiClient.delete(`/api/estimations/estimation-stacks/${id}`, config)
    },

    createFeature(estimationId, payload, config = {}) {
        return ApiClient.post(`/api/estimations/${estimationId}/features`, payload, config)
    },
    updateFeature(estimationId, featureId, payload, config = {}) {
        return ApiClient.put(`/api/estimations/${estimationId}/features/${featureId}`, payload, config)
    },
    deleteFeature(estimationId, featureId, config = {}) {
        return ApiClient.delete(`/api/estimations/${estimationId}/features/${featureId}`, config)
    },

    listRoles(params = {}, config = {}) {
        return ApiClient.get('/api/estimations/estimation-roles', { ...config, params })
    },
    createRole(payload, config = {}) {
        return ApiClient.post('/api/estimations/estimation-roles', payload, config)
    },
    updateRole(id, payload, config = {}) {
        return ApiClient.put(`/api/estimations/estimation-roles/${id}`, payload, config)
    },
    deleteRole(id, config = {}) {
        return ApiClient.delete(`/api/estimations/estimation-roles/${id}`, config)
    },
}

export default EstimationsService
